import { action, makeObservable, observable } from 'mobx';
import { v4 as uuid } from 'uuid';

import { ServiceData } from 'chaika-frontend-types/frontend-cms';

import { OptionType } from '@components/Select';
import { DateHelper } from '@utils/DateHelper';

export class ReferralForm {
    public static Name = 'referralForm' as const;

    @observable public id: string = uuid();
    @observable public organizationId?: string;
    @observable public selectedServiceId?: string;
    @observable public entryId?: string;
    @observable public medicalCaseIds: string[] = [];
    @observable public userId?: string;
    @observable public popularServices: ServiceData[] = [];
    @observable public usedServiceIds: string[] = [];
    @observable public referringDoctor?: OptionType<string>;
    @observable public initialLegalPlanId?: string;
    @observable public createCount: number = 1;
    @observable public groupId?: string;
    @observable public startDate: string = DateHelper.getStartOfDay().toISOString();
    @observable public duration: number = 30;
    @observable public comment: string = '';
    @observable public services: ServiceData[] = [];
    @observable public isUrgent: boolean = false;
    @observable public contractorId?: string;
    @observable public contractorCandidateIds: string[] = [];
    @observable public preferredLaboratoryIds: string[] = [];
    public pendingFavoriteGroupName?: string;

    public constructor() {
        makeObservable(this);
    }

    @action
    public setOrganizationId(organizationId?: string): void {
        this.organizationId = organizationId;
    }

    @action
    public setSelectedServiceId(selectedServiceId?: string): void {
        this.selectedServiceId = selectedServiceId;
    }

    @action
    public setEntryId(entryId?: string): void {
        this.entryId = entryId;
    }

    @action
    public setMedicalCaseIds(medicalCaseIds: string[]): void {
        this.medicalCaseIds = medicalCaseIds;
    }

    @action
    public setUserId(userId?: string): void {
        this.userId = userId;
    }

    @action
    public setPopularServices(popularServices: ServiceData[]): void {
        this.popularServices = popularServices;
    }

    @action
    public setUsedServiceIds(usedServiceIds: string[]): void {
        this.usedServiceIds = usedServiceIds;
    }

    @action
    public addUsedServiceId(usedServiceIds: string[]): void {
        this.usedServiceIds = [...this.usedServiceIds, ...usedServiceIds];
    }

    @action
    public setReferringDoctor(referringDoctor?: OptionType<string>): void {
        this.referringDoctor = referringDoctor;
    }

    @action
    public setInitialLegalPlanOption(initialLegalPlanId?: string): void {
        this.initialLegalPlanId = initialLegalPlanId;
    }

    @action
    public setCreateCount(createCount: number): void {
        this.createCount = createCount;
    }

    @action
    public setGroupId(groupId?: string): void {
        this.groupId = groupId;
    }

    public setPendingFavoriteGroupName(pendingFavoriteGroupName?: string): void {
        this.pendingFavoriteGroupName = pendingFavoriteGroupName;
    }

    @action
    public setStartDate(startDate: string): void {
        this.startDate = startDate;
    }

    @action
    public setDuration(duration: number): void {
        this.duration = duration;
    }

    @action
    public setComment(comment: string) {
        this.comment = comment;
    }

    @action
    public setServices(services: ServiceData[]) {
        this.services = services;
    }

    @action
    public setIsUrgent(isUrgent: boolean) {
        this.isUrgent = isUrgent;
    }

    @action
    public setContractorId(contractorId?: string): void {
        this.contractorId = contractorId;
    }

    @action
    public setContractorCandidateIds(contractorCandidateIds: string[]): void {
        this.contractorCandidateIds = contractorCandidateIds;
    }

    @action
    public setPreferredLaboratoryIds(preferredLaboratoryIds: string[]): void {
        this.preferredLaboratoryIds = preferredLaboratoryIds;
    }

    @action
    public reset(): void {
        this.resetForm();
        this.entryId = undefined;
        this.medicalCaseIds = [];
    }

    @action
    public resetForm(): void {
        this.id = uuid();
        this.organizationId = undefined;
        this.selectedServiceId = undefined;
        this.userId = undefined;
        this.usedServiceIds = [];
        this.referringDoctor = undefined;
        this.initialLegalPlanId = undefined;
        this.groupId = undefined;
        this.pendingFavoriteGroupName = undefined;
        this.createCount = 1;
        this.startDate = DateHelper.getStartOfDay().toISOString();
        this.duration = 30;
        this.comment = '';
        this.isUrgent = false;
        this.contractorId = undefined;
        this.contractorCandidateIds = [];
        this.preferredLaboratoryIds = [];
    }
}

export const referralForm = new ReferralForm();
